export default {
  payment(url, data) {
    return axios.post(url, data)
      .then(({data}) => {
        return data;
      });
  }
};
